/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Commission_Empty_Ledger_TitleInputs */



/**
* | output |
* | --- |
* | "No commission yet" |
*
* @param {Partner_Commission_Empty_Ledger_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_commission_empty_ledger_title = /** @type {((inputs?: Partner_Commission_Empty_Ledger_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Commission_Empty_Ledger_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Provision")
	return /** @type {LocalizedString} */ ("No commission yet")
});